module.exports = __webpack_public_path__ + "r-v3/img/sticker_21.9fe9cce4.svg";